import { Component, OnInit } from '@angular/core';
import { EndpointService } from './core/endpoint.service';
import { StateService } from './state/state.service';
import { Observable } from 'rxjs/Observable';
import { NavigationCancel, NavigationEnd, NavigationError, Router } from '@angular/router';
import { AuthService } from './core/auth/auth.service';
import { Analytics } from './core/service/analytics';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  showLoader = false; // true;

  constructor(private state: StateService,
    private auth: AuthService,
    private router: Router,
    private endpoint: EndpointService,
    private analytics: Analytics,
  ) { }

  ngOnInit(): void {
    this.endpoint.reauthenticator = this.auth;
    this.auth.init();

    this.analytics.logEvent("app_start");

    const timeout = 100;
    this.state.initialized$
      .switchMap(() => Observable.race<any>(Observable.timer(timeout), this.router.events
        .filter(e => e instanceof NavigationEnd || e instanceof NavigationCancel || e instanceof NavigationError)
        .debounceTime(timeout)))
      .first()
      .subscribe(() => this.showLoader = false);
  }


}



// WEBPACK FOOTER //
// ./src/app/app.component.ts